import Icon, {
	ICON_USER_CHECK_LINE,
	ICON_CIRCLE_CHECKMARK,
	ICON_RESPONSIBLE_LINE,
	ICON_DOCUMENT_CHECKMARK_LINE,
	ICON_DOCUMENT_SEARCH_LINE,
	ICON_CIRCLE_CLOSE
} from '~/components/icon/index.js';
import ButtonWrapper from './misc/button-wrapper.js';
import ActionScreen, {
	ActionScreenButton,
	ActionScreenLabelWithValue,
	ActionScreenHeadWrapper,
	ActionScreenMainTitle,
	ActionScreenSubTitle
} from './misc/action-screen.js';
import IconButtonClose from './misc/icon-button-close.js';
import SidebarHeader from './header/sidebar-header.js';
import useUIContext from '~/ui/use-ui-context';
import useScreenOrientation from '~/hooks/use-orientation';

const IconIdentifier = {
	NONE: 'none',
	DEFAULT_SUCCESS: 'default-success',
	DEFAULT_FAILURE: 'default-failure',
	HAS_DOCUMENTS: 'has-documents',
	EMPTY_DOCUMENTS: 'empty-documents',
	USER_CHECKMARK: 'user-checkmark',
	RESPONSIBLE_GAMING: 'responsible-gaming'
};

const ActionScreenConfirmMessage = ({
	buttons,
	labels,
	titleText,
	iconIdentifier,
	messageText,
	closeButton,
	fromRealityCheck = false,
	buttonWrapperClasses = '',
	sidebarHeaderTransparent = false,
	notInverted = false
}) => {
	const { withinSidebar, hasStaticHeader } = useUIContext();
	const orientation = useScreenOrientation();
	const isLandscapeOrientation = orientation === 'landscape';

	const isMessageTextArray = Array.isArray(messageText);
	const firstMessage = isMessageTextArray ? messageText.shift() : messageText;

	const notifyClasses = `modal-view ${withinSidebar ? '' : 'modal-view--fixed'} ${
		fromRealityCheck ? 'reality-check-confirm' : ''
	}`.trim();

	return (
		<div className={notifyClasses}>
			<ActionScreen hasStaticHeader={hasStaticHeader} type={iconIdentifier}>
				{closeButton && (
					<SidebarHeader
						Icon={
							<IconButtonClose onClick={() => closeButton()} className="at-icon-close page-head__close" />
						}
						inverted={!notInverted}
						transparent={sidebarHeaderTransparent}
						noBorderBottom
					/>
				)}

				<ActionScreenHeadWrapper
					className=""
					notInverted={notInverted}
					landscape={isLandscapeOrientation}
					type={iconIdentifier}
				>
					<>
						{iconIdentifier === IconIdentifier.DEFAULT_SUCCESS && (
							<Icon type={ICON_CIRCLE_CHECKMARK} onClick={() => {}} />
						)}
						{iconIdentifier === IconIdentifier.DEFAULT_FAILURE && <Icon type={ICON_CIRCLE_CLOSE} />}
						{iconIdentifier === IconIdentifier.HAS_DOCUMENTS && (
							<Icon type={ICON_DOCUMENT_CHECKMARK_LINE} onClick={() => {}} />
						)}
						{iconIdentifier === IconIdentifier.EMPTY_DOCUMENTS && (
							<Icon type={ICON_DOCUMENT_SEARCH_LINE} onClick={() => {}} />
						)}
						{iconIdentifier === IconIdentifier.RESPONSIBLE_GAMING && (
							<Icon type={ICON_RESPONSIBLE_LINE} onClick={() => {}} />
						)}
						{iconIdentifier === IconIdentifier.USER_CHECKMARK && (
							<Icon type={ICON_USER_CHECK_LINE} onClick={() => {}} />
						)}

						<ActionScreenMainTitle
							notInverted={notInverted}
							type={iconIdentifier}
							dataAt="main-title-limit-page"
						>
							{titleText}
						</ActionScreenMainTitle>
					</>

					<ActionScreenSubTitle notInverted={notInverted} type={iconIdentifier} dataAt="sub-title-limit-page">
						{firstMessage || ''}
					</ActionScreenSubTitle>
					{isMessageTextArray && messageText.length > 0 && (
						<div className="confirm-modal-list u-pl1 u-pr1 u-text-l">
							<ul className="link-list">
								{messageText.map(text => (
									<li className="link-list__item u-p1" key={`${text}`}>
										<p>{`${text}`}</p>
									</li>
								))}
							</ul>
						</div>
					)}
				</ActionScreenHeadWrapper>
				{labels &&
					labels.length > 0 &&
					labels.map(l => (
						<ActionScreenLabelWithValue
							inverted={!notInverted}
							key={l.label}
							label={l.label}
							value={l.value}
							landscape={isLandscapeOrientation}
						/>
					))}
				{buttons && buttons.length > 0 && (
					<ButtonWrapper
						transparent
						className={buttonWrapperClasses}
						pt={fromRealityCheck ? 3 : 5}
						pb={fromRealityCheck ? 3 : 5}
						data-at="button-container-limit-page"
					>
						<>
							{buttons.map(b => (
								<ActionScreenButton
									key={b.name}
									type="button"
									actionType={iconIdentifier}
									className={`btn action-screen btn-border-radius btn--action-screen-confirm ${b.class}`}
									onClick={() => b.onclick()}
									dataAt="logout-button-limit-page"
								>
									{b.text}
								</ActionScreenButton>
							))}
						</>
					</ButtonWrapper>
				)}
			</ActionScreen>
		</div>
	);
};

export { IconIdentifier };

export default ActionScreenConfirmMessage;
